import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue')
  },
  // 产品服务
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product.vue')
  },
  // 解决方案
  {
    path: '/dataSolutions',
    name: 'dataSolutions',
    component: () => import('../views/dataSolutions.vue')
  },
  {
    path: '/financialSolutions',
    name: 'financialSolutions',
    component: () => import('../views/financialSolutions.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('../views/newsDetails.vue')
  }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
